module.exports = __webpack_public_path__ + "static/media/presentation.19eda5a4.svg";